import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Solution} from '../../../../../Models/Solution';
import {Subscription} from 'rxjs';
import {SolutionService} from '../../../../../Services/solution.service';
import {Helper} from '../../../../../../helpers/helper.service';
import {ActionChangeStatus} from '../../../../../Models/ActionChangeStatus';
import {ServiceRequestService} from '../../../../../Services/service-request.service';

@Component({
  selector: 'app-solution-action-change-status',
  templateUrl: './solution-action-change-status.component.html',
  styleUrls: ['./solution-action-change-status.component.scss']
})
export class SolutionActionChangeStatusComponent implements OnInit, OnDestroy {

  @Input() Index: number;
  @Input() statusRequired: boolean = false;

  public solution: Solution = new Solution();
  private subscriptions: Subscription[] = [];
  public statuses = [];

  constructor(
    private solutionService: SolutionService,
    private requestService: ServiceRequestService,
    public helper: Helper
  ) {
  }

  ngOnInit() {
    this.getStatuses();
    this.subscriptions.push(
      this.solutionService.solution.subscribe(solution => {
        this.solution = solution;
        if (this.solution.solutionSteps[this.Index] && !this.solution.solutionSteps[this.Index].actionChangeStatus) {
          this.solution.solutionSteps[this.Index].actionChangeStatus = new ActionChangeStatus();
        } else if (typeof this.solution.solutionSteps[this.Index].actionChangeStatus.status === 'object') {
          this.solution.solutionSteps[this.Index].actionChangeStatus.status = this.solution.solutionSteps[this.Index].actionChangeStatus.status.id;
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  updateSolution() {
    this.solutionService.solution.next(this.solution);
  }

  getStatuses() {
    this.requestService.getServiceRequestStatuses().subscribe(res => {
      this.statuses = res['statuses'];
    });
  }
}
